import { render } from "./ResultsProgram.vue?vue&type=template&id=0f44374c"
import script from "./ResultsProgram.vue?vue&type=script&lang=js"
export * from "./ResultsProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__